import React from 'react';
import Script from 'next/script'
import isWebview from '@gerenciatd/next13.utils.common.is-webview'

const WebviewBridge = () => {
    if (isWebview()) {
        return (
            <Script crossOrigin strategy="beforeInteractive" src="https://unpkg.com/@tef-novum/webview-bridge/dist/webview-bridge-iife.min.js" />
        )
    }
    return null;
}



export default WebviewBridge;